export default __webpack_public_path__ + "static/media/contacts.8fd9a39e.svg";